import { dateTimeService } from "sprint-common-web";

export const getMiliseconds = (zulu: string): number => dateTimeService().milisecondsFromZulu(zulu);
